const commonConfig = require('./common');

const WebsiteHostname = 'www-dev.onestore.io'
const WebsiteOrigin = 'https://' + WebsiteHostname


const RESTAPIOrigin = 'https://api-dev.onestore.io'
const ApiBasePath = '/v1'

const _exports = {
  env: 'dev',

  auth0ClientID: "igizre4Xmj7mXtA8gz35Mr2hmqb1Hkum",

  JWTTokenStorageKey: 'onestore.dev.jwt_token',

  auth0WebsiteAudience: "https://api-dev.onestore.io/",

  restAPIURL: RESTAPIOrigin + ApiBasePath,

  CreateTokenPopupURL: WebsiteOrigin + '/#/app-login',
  LoginWebsitePopupURL: WebsiteOrigin + '/#/app-login',

  APIDomainName: "api-dev.onestore.io",
  WWWDomainName: "www-dev.onestore.io",
  WWWDomainName2: "www-dev2.onestore.io",
  CertificateArn: "arn:aws:acm:us-east-1:062399315300:certificate/4422e5eb-ca70-43f9-b65b-c6ec2039794e",
  DomainNamesEnabled: true,

  WebsiteOrigin: WebsiteOrigin,
  StaticOrigin: WebsiteOrigin,

  max_api_calls: 1500,
  max_namespaces: 50,
  max_tokens: 50,
  max_userdata_item_size_bytes: 5 * 1024,
  max_userdata_items_count: 10000,
  default_page_size: 10,
  max_page_size: 20
}

for (var k in commonConfig) _exports[k] = commonConfig[k]

module.exports = _exports


//////////////////
// WEBPACK FOOTER
// ../config/dev.js
// module id = uAm5
// module chunks = 1